import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-email-alert',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent {
  deviceId: string | null = null;
  notification: string | null = null;
  email: string | null = null;
  userId: string | null = null;
  accessToken: string | null = null;
  selectedOption: string | null = null;
  message: string = '';

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.deviceId = params['deviceId'] || "Unknown";
      this.notification = params['notification'];
      this.email = params['recipient'];
      this.userId = params['userId'];
      this.accessToken = params['accessToken'];
    });
  }

  selectOption(option: string): void {
    if (this.selectedOption === option) {
      this.selectedOption = null;
    } else {
      this.selectedOption = option;
    }
  }

  share(): void {
    if (!this.selectedOption) {
      alert("Please select an option.");
      return;
    }

    this.router.navigate(['/confirm'], {
      queryParams: {
        option: this.selectedOption,
        message: this.message,
        deviceId: this.deviceId,
        notification: this.notification,
        email: this.email,
        userId: this.userId,
        accessToken: this.accessToken
      }
    });
  }

  decline(): void {
    if (!this.email) {
      alert("User email not found.");
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(this.email)) {
      alert("Invalid email format.");
      return;
    }

    const emailDomain = this.email.split('@')[1].toLowerCase();
    let inboxUrl = "";

    if (emailDomain === "gmail.com") {
      inboxUrl = "https://mail.google.com";
    } else if (emailDomain === "outlook.com" || emailDomain === "hotmail.com" || emailDomain === "live.com") {
      inboxUrl = "https://outlook.live.com/mail/";
    } else if (emailDomain === "yahoo.com") {
      inboxUrl = "https://mail.yahoo.com/";
    } else {
      inboxUrl = `https://${emailDomain}`;
    }

    window.location.href = inboxUrl;
  }
}